import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Camera } from "lucide-react";
import { PaymentRecordBoard } from "./PaymentRecordBoard";
import { PhotoEscalationBanner } from "./PhotoEscalationBanner";

/** PM / 现场组员打开 /finance/project/:pid 时的精简视图：仅工程直接费用台账 + 完工照片补传 */
export const PmPaymentRecordView = ({ zh, api, pid, user }) => {
  const nav = useNavigate();
  const [tick, setTick] = useState(0);
  const [proj, setProj] = useState(null);
  return (
    <div className="space-y-5" data-testid="pm-payment-record-view">
      <PhotoEscalationBanner zh={zh} api={api} pid={pid} refreshKey={tick} />
      <div className="flex flex-wrap items-center gap-3">
        <button data-testid="pm-pr-back" onClick={() => nav(-1)}
          className="inline-flex items-center gap-1 text-sm text-slate-500 border border-slate-200 rounded-lg px-2.5 py-1.5 hover:text-red-600 hover:border-red-200 transition-colors">
          <ArrowLeft className="h-4 w-4" />{zh ? "返回" : "Back"}
        </button>
        <h1 className="text-xl sm:text-2xl font-bold text-slate-900 truncate max-w-[520px]" data-testid="pm-pr-address" data-keep-title>{proj?.address || pid}</h1>
        <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-red-700 bg-red-50 rounded px-2 py-0.5"><Camera className="h-3 w-3" />{zh ? "完工照片 · 工程直接费用" : "Completion photos · Direct costs"}</span>
        {proj?.manager && <span className="text-xs text-slate-500">PM {proj.manager}</span>}
      </div>
      <p className="text-xs text-slate-500" data-testid="pm-pr-hint">{zh ? "你以 PM / 现场身份查看：可上传完工照片、录入明细并转付款批次；项目收款、利润等财务数据仅财务可见。" : "PM / crew view: upload completion photos and manage direct-cost items. Client collections and profit are finance-only."}</p>
      <PaymentRecordBoard zh={zh} api={api} pid={pid} user={user} onChanged={() => setTick((t) => t + 1)} onLoaded={setProj} />
    </div>
  );
};
